import { useAuth } from '@/providers/auth.provider'
import { getUrlParams } from '@/utils/common'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getCollaboratorsForTasks } from '../Pages/Order.transform'
import { IsAdminRole } from '@/utils/users'

type Props = {
  children: any
  roles: Array<string>
  showComponent?: boolean
}

function PBFPermission(props: Props) {
  const [allowed, setallowed] = useState(false)
  const { user } = useAuth()

  const isWorkspaceAdmin = IsAdminRole(user)

  const { data, isLoading } = useQuery(
    'GET_COLLABORATOR_ROLE',
    async () => {
      return await getCollaboratorsForTasks(getUrlParams('orderKey'))
    },
    {
      cacheTime: 3600,
    }
  )

  useEffect(() => {
    if (isWorkspaceAdmin) {
      setallowed(true)
      return
    }
    if (!isLoading) {
      const currentUser = data?.find((item) => item.user.id == user.id)
      if (props?.roles?.some((role) => role == currentUser?.roles?.role)) {
        setallowed(true)
      } else {
        setallowed(false)
      }
    }
  }, [isLoading, props.roles, isWorkspaceAdmin])

  if (!allowed && !props.showComponent) return null
  if (!allowed && props.showComponent)
    return <div style={{ pointerEvents: 'none' }}>{props.children}</div>
  return <>{props.children}</>
}

export default PBFPermission
